"use client";

import { c as _c } from "react/compiler-runtime";
import type { WalletConsolidationState } from "@/entities/IProfile";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "@/components/auth/Auth";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import type { ApiWallet } from "@/generated/models/ApiWallet";
import { amIUser } from "@/helpers/Helpers";
import type { Page } from "@/helpers/Types";
import { commonApiFetch } from "@/services/api/common-api";
import { useQueries } from "@tanstack/react-query";
import { AnimatePresence } from "framer-motion";
import Link from "next/link";
import UserPageIdentityStatementsConsolidatedAddressesItem from "./UserPageIdentityStatementsConsolidatedAddressesItem";
export default function UserPageIdentityStatementsConsolidatedAddresses(t0) {
  const $ = _c(68);
  const {
    profile
  } = t0;
  const {
    address
  } = useSeizeConnectContext();
  const {
    activeProfileProxy
  } = useContext(AuthContext);
  const [isMyProfile, setIsMyProfile] = useState(true);
  let t1;
  let t2;
  if ($[0] !== address || $[1] !== profile) {
    t1 = () => setIsMyProfile(amIUser({
      profile,
      address
    }));
    t2 = [profile, address];
    $[0] = address;
    $[1] = profile;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== activeProfileProxy || $[5] !== isMyProfile) {
    t3 = () => isMyProfile && !activeProfileProxy;
    $[4] = activeProfileProxy;
    $[5] = isMyProfile;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const getCanEdit = t3;
  let t4;
  if ($[7] !== getCanEdit) {
    t4 = getCanEdit();
    $[7] = getCanEdit;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const [canEdit, setCanEdit] = useState(t4);
  let t5;
  if ($[9] !== getCanEdit) {
    t5 = () => setCanEdit(getCanEdit());
    $[9] = getCanEdit;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== activeProfileProxy || $[12] !== isMyProfile) {
    t6 = [isMyProfile, activeProfileProxy];
    $[11] = activeProfileProxy;
    $[12] = isMyProfile;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  useEffect(t5, t6);
  const getPrimaryAddress = _temp2;
  let t7;
  if ($[14] !== profile) {
    t7 = getPrimaryAddress(profile);
    $[14] = profile;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const [primaryAddress, setPrimaryAddress] = useState(t7);
  let t8;
  let t9;
  if ($[16] !== profile) {
    t8 = () => {
      setPrimaryAddress(getPrimaryAddress(profile));
    };
    t9 = [profile];
    $[16] = profile;
    $[17] = t8;
    $[18] = t9;
  } else {
    t8 = $[17];
    t9 = $[18];
  }
  useEffect(t8, t9);
  let t10;
  if ($[19] !== primaryAddress) {
    t10 = wallets => {
      const sorted = [...wallets];
      sorted.sort((a, b) => {
        if (a.wallet.toLowerCase() === primaryAddress) {
          return -1;
        }
        if (b.wallet.toLowerCase() === primaryAddress) {
          return 1;
        }
        return b.tdh - a.tdh;
      });
      return sorted;
    };
    $[19] = primaryAddress;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const sortByPrimary = t10;
  let t11;
  if ($[21] !== profile.wallets) {
    t11 = profile.wallets ?? [];
    $[21] = profile.wallets;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== sortByPrimary || $[24] !== t11) {
    t12 = sortByPrimary(t11);
    $[23] = sortByPrimary;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const [sortedByPrimary, setSortedByPrimary] = useState(t12);
  let t13;
  if ($[26] !== profile.wallets || $[27] !== sortByPrimary) {
    t13 = () => {
      setSortedByPrimary(sortByPrimary(profile.wallets ?? []));
    };
    $[26] = profile.wallets;
    $[27] = sortByPrimary;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== primaryAddress || $[30] !== profile) {
    t14 = [profile, primaryAddress];
    $[29] = primaryAddress;
    $[30] = profile;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  useEffect(t13, t14);
  let t15;
  if ($[32] !== profile.wallets) {
    t15 = profile.wallets ?? [];
    $[32] = profile.wallets;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== address || $[35] !== t15) {
    let t17;
    if ($[37] !== address) {
      t17 = wallet_0 => ({
        queryKey: [QueryKey.WALLET_CONSOLIDATIONS_CHECK, wallet_0.wallet.toLowerCase()],
        queryFn: () => commonApiFetch({
          endpoint: `consolidations/${wallet_0.wallet.toLowerCase()}`,
          params: {
            show_incomplete: "true"
          }
        }),
        enabled: !!address
      });
      $[37] = address;
      $[38] = t17;
    } else {
      t17 = $[38];
    }
    t16 = t15.map(t17);
    $[34] = address;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[39] !== t16) {
    t17 = {
      queries: t16
    };
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  const walletConsolidations = useQueries(t17);
  const [showDelegationCenter, setShowDelegationCenter] = useState(false);
  let t18;
  let t19;
  if ($[41] !== address || $[42] !== walletConsolidations) {
    t18 = () => {
      if (walletConsolidations.length === 0 || !address) {
        setShowDelegationCenter(false);
        return;
      }
      const haveAffectedWallets = walletConsolidations.some(w => w.data?.data.some(c => c.wallet1.toLowerCase() === address?.toLowerCase() || c.wallet2.toLowerCase() === address?.toLowerCase()));
      setShowDelegationCenter(haveAffectedWallets);
    };
    t19 = [walletConsolidations, address];
    $[41] = address;
    $[42] = walletConsolidations;
    $[43] = t18;
    $[44] = t19;
  } else {
    t18 = $[43];
    t19 = $[44];
  }
  useEffect(t18, t19);
  let t20;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">Consolidated Addresses</span>;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="tw-flex tw-items-center tw-justify-between">{t20}<button type="button" aria-label="Statements help" className="tw-inline-flex tw-h-8 tw-w-8 tw-appearance-none tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-text-iron-400 hover:tw-bg-white/5 hover:tw-text-iron-200 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-emerald-400" data-tooltip-id="statements-help"><svg className="tw-h-4 tw-w-4 tw-flex-shrink-0 tw-text-iron-400" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></button></div>;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== canEdit || $[48] !== primaryAddress || $[49] !== sortedByPrimary) {
    let t23;
    if ($[51] !== canEdit || $[52] !== primaryAddress) {
      t23 = wallet_1 => <UserPageIdentityStatementsConsolidatedAddressesItem key={wallet_1.wallet} address={wallet_1} primaryAddress={primaryAddress} canEdit={canEdit} />;
      $[51] = canEdit;
      $[52] = primaryAddress;
      $[53] = t23;
    } else {
      t23 = $[53];
    }
    t22 = sortedByPrimary.map(t23);
    $[47] = canEdit;
    $[48] = primaryAddress;
    $[49] = sortedByPrimary;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[54] !== t22) {
    t23 = <ul className="tw-mb-0 tw-mt-4 tw-list-none tw-space-y-3 tw-pl-0">{t22}</ul>;
    $[54] = t22;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  const t24 = `/delegation/wallet-checker?address=${primaryAddress}`;
  let t25;
  if ($[56] !== t24) {
    t25 = <Link href={t24} className="tw-relative tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-white/[0.04] tw-px-2.5 tw-py-2 tw-text-xs tw-font-medium tw-text-iron-200 tw-no-underline tw-ring-0 tw-transition tw-duration-300 tw-ease-out hover:tw-bg-white/[0.08] hover:tw-text-iron-200 focus:tw-z-10 focus:tw-outline-none">Wallet Checker</Link>;
    $[56] = t24;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== showDelegationCenter) {
    t26 = showDelegationCenter && <Link href="/delegation/delegation-center" className="tw-relative tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-white/[0.04] tw-px-2.5 tw-py-2 tw-text-xs tw-font-medium tw-text-iron-200 tw-no-underline tw-ring-0 tw-transition tw-duration-300 tw-ease-out hover:tw-bg-white/[0.08] hover:tw-text-iron-200 focus:tw-z-10 focus:tw-outline-none">Delegation Center</Link>;
    $[58] = showDelegationCenter;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t26) {
    t27 = <AnimatePresence mode="wait" initial={false}>{t26}</AnimatePresence>;
    $[60] = t26;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  let t28;
  if ($[62] !== t25 || $[63] !== t27) {
    t28 = <div className="tw-space-x-3 tw-pt-5 xl:tw-pt-4">{t25}{t27}</div>;
    $[62] = t25;
    $[63] = t27;
    $[64] = t28;
  } else {
    t28 = $[64];
  }
  let t29;
  if ($[65] !== t23 || $[66] !== t28) {
    t29 = <div>{t21}{t23}{t28}</div>;
    $[65] = t23;
    $[66] = t28;
    $[67] = t29;
  } else {
    t29 = $[67];
  }
  return t29;
}
function _temp2(p) {
  if (p.primary_wallet) {
    return p.primary_wallet.toLowerCase();
  }
  const highestTdhWallet = p.wallets?.reduce(_temp);
  return highestTdhWallet?.wallet.toLowerCase() ?? null;
}
function _temp(highest, wallet) {
  if (wallet.tdh > highest.tdh) {
    return wallet;
  }
  return highest;
}